export default __webpack_public_path__ + "static/assets/b8aff50f8793580d69361afc9cc42246.png";